import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import logoWhite from "@/assets/logo-white.webp";

const WEBSTORE_URL = "https://avoinna24.fi/takomo/webstore";

export default function Footer() {
  return (
    <footer className="bg-secondary border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img src={logoWhite} alt="Takomo" width={173} height={56} className="h-14 mb-4" />
            <p className="text-muted-foreground text-sm leading-relaxed">
              Kaksi laadukasta kuntosalia Jokelassa ja Kellokoskella. Molempiin kulku samalla kortilla.
            </p>
          </div>

          {/* Sivut */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">Sivut</h3>
            <div className="flex flex-col gap-2">
              {[
                { label: "Kuntosalit", path: "/kuntosalit" },
                { label: "Hinnasto", path: "/hinnasto" },
                { label: "Valmennus", path: "/valmennus" },
                { label: "Hieronta", path: "/hieronta" },
                { label: "Aukiolot", path: "/aukiolot" },
              ].map((l) => (
                <Link key={l.path} to={l.path} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                  {l.label}
                </Link>
              ))}
              <a href={WEBSTORE_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors text-sm font-semibold">
                Verkkokauppa →
              </a>
            </div>
          </div>

          {/* Yhteystiedot */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">Yhteystiedot</h3>
            <div className="flex flex-col gap-3 text-sm text-muted-foreground">
              <a href="tel:0443394158" className="flex items-center gap-2 hover:text-foreground transition-colors">
                <Phone size={16} /> 044 3394158
              </a>
              <a href="tel:0449980593" className="flex items-center gap-2 hover:text-foreground transition-colors">
                <Phone size={16} /> 044 9980593
              </a>
              <a href="mailto:info@kuntotakomo.fi" className="flex items-center gap-2 hover:text-foreground transition-colors">
                <Mail size={16} /> info@kuntotakomo.fi
              </a>
            </div>
          </div>

          {/* Sijainnit */}
          <div>
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">Sijainnit</h3>
            <div className="flex flex-col gap-3 text-sm text-muted-foreground">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <div>
                  <p className="font-medium text-foreground">Jokela</p>
                  <p>Keskustie 2</p>
                  <p className="text-foreground text-xs font-semibold mt-1">24/7</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <div>
                  <p className="font-medium text-foreground">Kellokoski</p>
                  <p>Vanha Valtatie 195</p>
                  <p className="text-foreground text-xs font-semibold mt-1">05:00–22:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-center text-muted-foreground text-xs flex items-center justify-center gap-2">
          <span>© {new Date().getFullYear()} Kuntosali Takomo. Kaikki oikeudet pidätetään.</span>
          <Link to="/admin/login" className="text-muted-foreground/50 hover:text-muted-foreground/70 transition-colors text-[10px]">Hallinta</Link>
        </div>
      </div>
    </footer>
  );
}
